import { useEffect } from 'react';

import { useInterpretation2DSeismicViewer } from '../hooks/useInterpretation2DSeismicViewer';
import { SeismicInterpretationPopup } from './SeismicInterpretationPopup';
import { ILineString } from 'features/seismic/models/interfaces/ILineString';

export function SeismicInterpretation2DViewer(props: Props){
    const interpretationSettings = useInterpretation2DSeismicViewer(props.dataGeometryLine);

    return <SeismicInterpretationPopup {...props} interpretationSettings={interpretationSettings} />;
}

interface Props {
    opened: boolean;
    setOpened: (value: boolean) => void;
    dataGeometryLine: ILineString | null;
}